import React, { useCallback, useState } from 'react';
import CatalogueOverlappingImages from '../../../../../Common/CatalogueOverlappingImages';
import CatalogueLib, { CREATING_NEW_CATALOGUE } from 'qs-data-manager/Catalogues';
import eventbus from 'eventing-bus';
import { isEnterKey } from 'qs-helpers';
import { getI18N } from 'qs-services/i18N';

import './styles.scss';

export default () => {
  const [title, setTitle] = useState('');

  const { t } = getI18N();

  const onSaveClick = useCallback(() => {
    const meta = {
      title
    };
    eventbus.publish(
      CREATING_NEW_CATALOGUE.NEW_CATALOGUE_EB_KEY,
      CREATING_NEW_CATALOGUE.SAVE_CATALOGUE
    );
    CatalogueLib.createNewCatalogue(meta);
  }, [title]);

  const setInput = useCallback(e => {
    e.stopPropagation();
    const value = e.target.value;
    setTitle(value);
  }, []);

  const onKeyPress = useCallback(
    e => {
      e.stopPropagation();
      const isEnter = isEnterKey(e);
      if (isEnter) {
        onSaveClick(e);
      }
    },
    [onSaveClick]
  );

  return (
    <div id={'SkeletonCatalogueContainer'}>
      <div id={'SkeletonCatalogue'}>
        <div className={'catalogueProductsContainer'}>
          <CatalogueOverlappingImages />
        </div>
        <div className={'titleContainer'}>
          <input
            autoFocus
            value={title}
            onChange={setInput}
            className={'title'}
            placeholder={t('type_title')}
            onKeyPress={onKeyPress}
          />
        </div>

        {!!title.length ? (
          <div onClick={onSaveClick} className={'saveContainer'}>
            {t('save')}
          </div>
        ) : null}
      </div>
    </div>
  );
};
